import { Stack, Typography } from "@mui/material";
import { PageContainer } from "share-components/templates/page/page-container";

export const HomeBoard = () => {
  return (
    <PageContainer>
      <Stack>
        <Typography variant="h6">
          Phần mềm quản lý công ty bao bì á châu
        </Typography>
      </Stack>

      <Stack>
        <Typography>
          Phần mềm quản lý khách hàng, sản phẩm, kho vật tư và sản xuất.
        </Typography>
      </Stack>
    </PageContainer>
  );
};
